<template>
  <div class="container">
    <div class="field">
      <label class="label">Add new friend</label>
      <div class="control is-expanded">
        <input
          v-bind:class="{input: true}"
          type="text"
          v-model="searchFriend"
          v-on:keyup.enter="() => sendFriendRequest(searchFriend)"
          placeholder="Username"
        />
      </div>
    </div>
    <div v-if="user.requestedFriends.length > 0">
      <h3 class="title is-6">Pending requests</h3>
      <ul>
        <li
          v-for="request in user.requestedFriends"
          v-bind:key="request.id"
        >{{request.requestedUserName}}</li>
      </ul>
    </div>
    <div v-if="user.friendRequests.length > 0">
      <h3 class="title is-6">People who want to be friends with you</h3>
      <ul>
        <li v-for="request in user.friendRequests" v-bind:key="request.id">
          {{request.requestingUserId}}: {{request.requestingUserName}}
          <br />
          <button class="button is-primary" v-on:click="() => confirmFriendship(request)">Confirm</button>
        </li>
      </ul>
    </div>
    <div v-if="friends.length > 0" class="columns is-multiline">
      <div class="column is-12">
        <h6 class="title is-4 is-spaced">Friends</h6>
      </div>
      <div class="column is-6" v-for="friend in friends" v-bind:key="friend.id">
        <div class="box">
          <div class="media">
            <div class="media-left">
              <router-link class="image is-64x64" v-bind:to="'/friends/' + friend.userFriendship.friendId">
                <img src="https://bulma.io/images/placeholders/128x128.png">
              </router-link>
            </div>
            <div class="media-content">
              <h5 class="title is-5 friendship-link">
                  <router-link v-bind:to="'/friends/' + friend.userFriendship.friendId">
                    {{friend.name}}
                  </router-link>    
                </h5>
              <label class="checkbox">
                <input type="checkbox" v-model="friend.userFriendship.shareAll" v-on:change="() => toggleShareAll(friend.userFriendship)">
                Share all images and galleries
              </label>
              <hr>
              <button class="button is-danger" v-on:click="unfriend(friend)">
                Unfriend
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  data() {
    return {
      searchFriend: ""
    };
  },
  computed: {
    ...mapState(["user", "friends"])
  },
  components: {},
  methods: {
    ...mapActions(["sendFriendRequest", "confirmFriendship", "toggleShareAll", "unfriend"])
  }
};
</script>
